import {DOM} from '../../../../../plugins/levcharity/resources/scripts/helpers/DOM'

export class MyAccountStats {
    #chartData = {};
    #totalsList = {};
    #chartDataAlreadyFetched = false;
    #activeTimeline = '1y';

    #fetching = {};

    constructor() {
        this.#fetchData();
        this.#addEvents();
    }

    async #fetchData() {
        this.#fetchStatsChart()
        this.#fetchDonations();
        this.#datatable();
    }

    async #fetchStatsChart() {
        if (this.#fetching?.chart) return;
        const {Helper} = await import('../../../../../plugins/levcharity/resources/scripts/helpers/Helper.js' /* webpackChunkName: "helper" */);

        const statsChartWrapper = DOM.el('.custom_bar_chart_wrapper');

        this.#fetching.chart = true;
        Helper.request(admin_ajax[0], {
            action: statsChartWrapper.dataset.action,
            token: statsChartWrapper.dataset.token,
            timeline: this.#activeTimeline
        })
            .then((response) => {
                if (response.success) {
                    this.#chartData = {
                        totalToday: response.total_today,
                        totalRaised: response.total_raised,
                        totalDonors: response.total_donors,
                        teamMembers: response.team_members,
                        goal: response.goal,
                        data: response.chart_data
                    }
                    this.#renderChart();
                    this.#chartDataAlreadyFetched = true;
                }

                this.#fetching.chart = false;
            })
            .catch((error) => {
                console.error(error)
                this.#fetching.chart = false;
            })
    }

    async #fetchDonations() {
        if (this.#fetching?.donations) return;
        const {Helper} = await import('../../../../../plugins/levcharity/resources/scripts/helpers/Helper.js' /* webpackChunkName: "helper" */);

        const accountsBarWrapper = DOM.el('.accounts_bar');

        this.#fetching.totals = true;
        Helper.request(admin_ajax[0], {
            action: accountsBarWrapper.dataset.action,
            token: accountsBarWrapper.dataset.token,
        })
            .then((response) => {
                if (response.success) {
                    this.#totalsList = {
                        recentDonations: response.recent_donations,
                        participants: response?.participants || [],
                        topDonations: response?.top_donations || [],
                        topPrizes: response?.top_prizes || [],
                    }
                }

                this.#renderTotals();
                this.#fetching.totals = false;
            })
            .catch((error) => {
                console.error(error)
                this.#fetching.totals = false;
            })

    }

    async #addEvents() {
        const {gsap} = await import('gsap')

        let timeout = null;

        DOM.addEvent('mouseover', '.custom_bar_chart_wrapper .chart_bar:not(.empty)', (event, bar) => {
            if (!window.matchMedia("(pointer: coarse)").matches) {
                clearTimeout(timeout);
                timeout = null;
                this.#activateChartBar(bar);
            }
        });
        DOM.addEvent('mouseout', '.custom_bar_chart_wrapper .chart_bar:not(.empty)', (event, bar) => {
            if (!window.matchMedia("(pointer: coarse)").matches) {
                timeout = setTimeout(() => {
                    this.#deactivateChartBar(bar);
                }, 300);
            }
        });

        DOM.addEvent('click', '.custom_bar_chart_wrapper .chart_bar:not(.empty)', (event, bar) => {
            const active = DOM.el('.custom_bar_chart_wrapper .chart_bar.active')
            if (active) {
                const vars = this.#deactivateChartBar(active, timeout, interval);
                interval = vars.interval
                timeout = vars.timeout
            }
            const vars = this.#activateChartBar(bar, timeout, interval);
            interval = vars.interval
            timeout = vars.timeout
        })

        DOM.addEvent('click', document, (event, bar) => {
            if (!DOM.compareElement(event.target, '.custom_bar_chart_wrapper .chart_bar:not(.empty)')) {
                const active = DOM.el('.custom_bar_chart_wrapper .chart_bar.active')
                if (active) {
                    const vars = this.#deactivateChartBar(active, timeout, interval);
                    interval = vars.interval
                    timeout = vars.timeout
                }
            }
        })

        DOM.addEvent('click', '.custom_bar_chart_wrapper .period_buttons button', (event, button) => {
            event.preventDefault();
            if (this.#fetching?.chart) return;
            this.#activeTimeline = button.dataset.period;
            const currentActive = DOM.el('.custom_bar_chart_wrapper .period_buttons button.active')
            currentActive.classList.remove('active')
            button.classList.add('active');

            this.#fetchStatsChart();
        })
        DOM.addEvent('click', '.accounts_bar .buttons_group button', (event, button) => {
            const current = DOM.el('.accounts_bar .buttons_group button.active');

            current.classList.remove('active');
            button.classList.add('active');

            const recent = DOM.el('.accounts_bar .recent_donations')
            const tops = DOM.el('.accounts_bar .tops')
            const topPrizes = DOM.el('.accounts_bar .top_prizes')

            if (button.classList.contains('recent_btn')) {
                recent.style.display = '';
                tops.style.display = 'none';

                if (topPrizes) {
                    topPrizes.style.display = 'none';
                }
            } else if (button.classList.contains('top_prizes_btn')) {
                recent.style.display = 'none';
                tops.style.display = 'none';
                topPrizes.style.display = '';
            } else {
                recent.style.display = 'none';
                tops.style.display = '';

                if (topPrizes) {
                    topPrizes.style.display = 'none';
                }
            }
        })

        DOM.addEvent('click', '.html_chart_wrapper .arrow-left', (event) => {
           const scrollChartBar = DOM.el('.html_chart');
           scrollChartBar.scrollBy({ left: -150, behavior: "smooth" })
        });

        DOM.addEvent('click', '.html_chart_wrapper .arrow-right', (event) => {
            const scrollChartBar = DOM.el('.html_chart');
            scrollChartBar.scrollBy({ left: 150, behavior: "smooth" })
        });



    }

    async #activateChartBar(bar, timeout, interval) {
        const {gsap} = await import('gsap')
        clearTimeout(timeout)
        const placeholder = DOM.el('.custom_bar_chart_wrapper .placeholder')
        placeholder.textContent = bar.dataset.value

        if (timeout) clearTimeout(timeout);
        if (interval) clearInterval(interval);

        bar.classList.add('active')

        const span = DOM.el('.chart_bar_inner span', bar);

        const animate = () => {
            let top = span.offsetTop - placeholder.offsetHeight - 8;
            let left = bar.offsetLeft;

            if (placeholder.offsetWidth > bar.offsetWidth) {
                left -= (placeholder.offsetWidth - bar.offsetWidth) / 2
            } else {
                left += (bar.offsetWidth - placeholder.offsetWidth) / 2
            }

            gsap.to(placeholder, {
                top: top,
                left: left,
                autoAlpha: 1,
                duration: .2
            })
        }

        interval = setInterval(() => {
            animate();
        }, 50)

        timeout = setTimeout(() => {
            clearInterval(interval);
        }, 100);

        return {interval, timeout}
    }

    async #deactivateChartBar(bar, timeout, interval) {
        const {gsap} = await import('gsap')
        clearInterval(interval)
        bar.classList.remove('active')
        timeout = setTimeout(() => {
            const placeholder = DOM.el('.custom_bar_chart_wrapper .placeholder')
            gsap.to(placeholder, {
                autoAlpha: 0,
                duration: .2,
            })
        }, 300)
        return {interval, timeout}
    }

    #renderChart() {
        const wrapper = DOM.el('.levcharity_my_account_content');
        const statsChartWrapper = DOM.el('.custom_bar_chart_wrapper', wrapper);
        const currencySymbol = statsChartWrapper.dataset.currencySymbol
        const progressbar = DOM.el('.progress-bar-wrapper', wrapper);
        const totalsToday = DOM.el('.totals_total', wrapper);
        const raised = DOM.els('.total_raised', wrapper);
        const goal = DOM.el('.goal', wrapper);
        const totalDonors = DOM.el('.total_donors', wrapper);
        const teamMembers = DOM.el('.team_members', wrapper);
        const htmlChart = DOM.el('.html_chart', wrapper);

        let chartMax = 0;
        let fillingBarsCount = 0;
        this.#chartData.data.forEach((bar) => {
            if (bar.value > chartMax) {
                chartMax = bar.value
            }

        })

        const bars = [];

        htmlChart.innerHTML = '';

        if (this.#chartData.data.length) {
            htmlChart.append(...this.#chartData.data.map((bar) => {
                const value = bar.value ? (
                    bar.value / (chartMax / 100)
                ) : 0;

                const barElement = DOM.create('div', {
                    className: ['chart_bar', (!bar.value ? 'empty' : '')],
                    dataValue: currencySymbol + bar.value.toFixed(2)
                }, [
                    DOM.create('div', {className: 'chart_bar_inner'}, [
                        DOM.create('span')
                    ]),
                    DOM.create('div', {className: 'chart_bar_label', dataLevTooltip: bar.label_description}, bar.label)
                ])

                if (bar.value) {
                    bars.push({
                        barElement,
                        value
                    })
                }

                return barElement;
            }), DOM.create('span', {className: 'placeholder'}));
        } else {
            htmlChart.append(DOM.create('p', {className: 'no-data'}, wp.i18n.__('Start Fundraising to see statistics here', 'chaiathon')))
        }

        bars.forEach((item, index) => {
            setTimeout(() => {
                DOM.el('.chart_bar_inner span', item.barElement).style.height = item.value + '%'
            }, 50 * (index + 1))
        })

        if (!this.#chartDataAlreadyFetched) {
            totalsToday && this.#numberAnimation(this.#chartData.totalToday, totalsToday, currencySymbol);
            raised.length && [...raised].forEach(e => this.#numberAnimation(this.#chartData.totalRaised, e, currencySymbol));
            goal && this.#numberAnimation(this.#chartData.goal, goal, currencySymbol);
            totalDonors && this.#numberAnimation(this.#chartData.totalDonors, totalDonors, '', '', 0, false);
            teamMembers && this.#numberAnimation(this.#chartData.teamMembers, teamMembers, '', '', 0, false);
            const percentage = Math.min(100, this.#chartData.totalRaised / (+this.#chartData.goal / 100));
            progressbar.style.setProperty('--progress', percentage)
            if(percentage === 100){
                progressbar && this.#numberAnimation(percentage, DOM.el('.circular-progress-percentage', progressbar), '', '%', null, false)
            }else{
                progressbar && this.#numberAnimation(percentage, DOM.el('.circular-progress-percentage', progressbar), '', '%')
            }
        }
    }

    #renderTotals() {
        const accountsBarWrapper = DOM.el('.accounts_bar');
        const currencySymbol = accountsBarWrapper.dataset.currencySymbol

        const recentDonations = DOM.el('.recent_donations', accountsBarWrapper);
        const tops = DOM.el('.tops', accountsBarWrapper);
        const topPrizes = DOM.el('.top_prizes', accountsBarWrapper);


        const userSVG = `<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M42.672 42.672C41.2482 44.1066 39.6941 45.3239 38.0421 46.3238C30.0647 51.2254 19.9353 51.2254 11.9579 46.3238C10.3059 45.3239 8.75177 44.1066 7.32801 42.672C-2.44267 32.9122 -2.44267 17.0878 7.32801 7.32801C17.0878 -2.44267 32.9122 -2.44267 42.672 7.32801C52.4427 17.0878 52.4427 32.9122 42.672 42.672Z" fill="#00ADEF"/>
            <path d="M25.0009 28.2604C29.8028 28.2604 33.6956 24.3676 33.6956 19.5657C33.6956 14.7637 29.8028 10.871 25.0009 10.871C20.1989 10.871 16.3062 14.7637 16.3062 19.5657C16.3062 24.3676 20.1989 28.2604 25.0009 28.2604Z" fill="#0076A3"/>
            <path d="M38.0434 41.3026V46.3238C30.066 51.2254 19.9366 51.2254 11.9592 46.3238V41.3026C11.9592 34.0968 17.7956 28.2605 25.0013 28.2605C32.207 28.2605 38.0434 34.0968 38.0434 41.3026Z" fill="#0076A3"/>
            <path opacity="0.3" d="M25.0009 5.43688C27.8017 5.43688 30.0808 3.30993 30.3764 0.588491C28.644 0.209184 26.8475 0.00268555 25.0009 0.00268555C11.1948 0.00268555 0.00366211 11.1939 0.00366211 25C0.00366211 26.8465 0.210161 28.643 0.589468 30.3755C3.312 30.0798 5.43785 27.8008 5.43785 25C5.43785 14.2131 14.2141 5.43688 25.0009 5.43688Z" fill="white"/>
            <path opacity="0.15" d="M49.4122 19.6243C46.6897 19.9199 44.5638 22.199 44.5638 24.9998C44.5638 35.7866 35.7876 44.5629 25.0007 44.5629C22.2 44.5629 19.9209 46.6898 19.6252 49.4112C21.3577 49.7906 23.1542 49.9971 25.0007 49.9971C38.8069 49.9971 49.998 38.8059 49.998 24.9998C49.998 23.1532 49.7915 21.3567 49.4122 19.6243Z" fill="black"/>
            <path d="M6.57298 17.3127C6.3241 17.3127 6.07304 17.2551 5.83611 17.1355C5.03293 16.728 4.7134 15.7466 5.12097 14.9434C7.31529 10.621 10.9236 7.07358 15.2796 4.95316C16.0872 4.55864 17.0642 4.89556 17.4588 5.70525C17.8533 6.51494 17.5164 7.49093 16.7067 7.88436C12.9853 9.69612 9.90306 12.7273 8.02826 16.4193C7.74025 16.9866 7.16748 17.3127 6.57298 17.3127Z" fill="white"/>
        </svg>`;
        const renderCard = (title, date, metadata = '', number = true, image = true) => {
            const card = DOM.create('div', {className: 'account_block'})
            card.innerHTML = image ? userSVG : '';

            const dateElement = date && DOM.create('span', {className: 'date'}, date);
            const numberElement = number && DOM.create('span', {className: 'number'}, currencySymbol + 0.00);
            const seperatedPoint = DOM.create('span', {className: 'seperator'}, '•')
            const metadataElement = DOM.create('span', {})
            metadataElement.innerHTML = metadata
            const account_block_texts = DOM.create('div', {className: 'account_block_texts'}, [
                DOM.create('div', {}, title),
                DOM.create('p', {}, [
                    ...(number ? [numberElement] : []),
                    ...(number && date ? [seperatedPoint] : []) ,
                    ...(date ? [dateElement] : [])
                ]),
                metadata ? metadataElement : null
            ])

            card.append(account_block_texts)

            return {
                numberElement,
                card
            }
        }

        recentDonations.innerHTML = '';
        tops.innerHTML = '';
        if (topPrizes) {
            topPrizes.innerHTML = '';
        }

        if(this.#totalsList.recentDonations.length) {
            recentDonations.append(...this.#totalsList.recentDonations.map((donation) => {
                const {
                    numberElement,
                    card
                } = renderCard(donation.first_name + ' ' + donation.last_name, donation.order_date, donation.metadata_html);

                const initialInnerHTML = numberElement.innerHTML
                numberElement.innerHTML = donation.currency;
                const currency = numberElement.innerHTML
                numberElement.innerHTML = initialInnerHTML;


                setTimeout(() => {
                    this.#numberAnimation(donation.total, numberElement, currency)
                });

                return card;
            }))
        } else {
            recentDonations.append(DOM.create('p', {className: 'no-data'}, wp.i18n.__('Start Fundraising to see statistics here', 'chaiathon')))
        }

        if(this.#totalsList.participants.length) {
            tops.append(...this.#totalsList.participants.map((participant) => {
                const {numberElement, card} = renderCard(participant.name, '', participant.created_at);

                setTimeout(() => {
                    this.#numberAnimation(participant.total_amount, numberElement, currencySymbol)
                });

                return card;
            }))
        } else if(this.#totalsList.topDonations.length) {
            tops.append(...this.#totalsList.topDonations.map((donation) => {
                const {numberElement, card} = renderCard(donation.first_name + ' ' + donation.last_name, donation.order_date, donation.metadata_html);

                const initialInnerHTML = numberElement.innerHTML
                numberElement.innerHTML = donation.currency;
                const currency = numberElement.innerHTML
                numberElement.innerHTML = initialInnerHTML;


                setTimeout(() => {
                    this.#numberAnimation(donation.total, numberElement, currency)
                });

                return card;
            }))
        } else {
            tops.append(DOM.create('p', {className: 'no-data'}, wp.i18n.__('Start Fundraising to see statistics here', 'chaiathon')))
        }

        if (this.#totalsList.topPrizes.length) {
            topPrizes.append(...this.#totalsList.topPrizes.map((prize) => {
                const {numberElement, card} = renderCard(prize.name, '', prize.metadata_html, false, false);

                return card;
            }))
        }
    }

    async #numberAnimation(to, el, prefix, suffix = '', from = 0, withFractions = true) {
        const {gsap} = await import('gsap')

        gsap.to(
            { value: from },
            {
                value: +to,
                duration: .8,
                ease: "power2.inOut",
                onUpdate: function() {
                    el.textContent = prefix + this.targets()[0].value.toFixed(withFractions ? 2 : 0) + suffix;
                }
            }
        );
    }

        async #datatable() {
        const {Helper} = await import('../../../../../plugins/levcharity/resources/scripts/helpers/Helper.js' /* webpackChunkName: "helper" */);

        const leaderboardsContainer = DOM.el('.leaderboards-container');
        const _id = leaderboardsContainer.dataset.id;
        let position = -1; // Variable to store the user's position

        Object.keys(window.LevDataTables.datatableInstances).forEach((id) => {
            const DataTable = window.LevDataTables.datatableInstances[id];

            DataTable.on('draw.dt', () => {
                const data = DataTable.context[0].json.data;


                position = data.findIndex(row => _id === row.id);

                const positionString = Helper.ordinalNumberFormatter(position+1)
                const positionElement = DOM.el('.position', leaderboardsContainer);

                if (positionElement) {
                    positionElement.textContent = positionString
                }
            });
        });

        DOM.addEvent('click', '#gotoposition', (event, button) => {
            if (position === -1) {
                return;
            }

            Object.keys(window.LevDataTables.datatableInstances).forEach((id) => {
                const DataTable = window.LevDataTables.datatableInstances[id];

                const pageSize = DataTable.page.len();
                const pageNum = Math.floor(position / pageSize);

                // Paginate to the correct page
                DataTable.page(pageNum).draw('page');

                setTimeout(() => {
                    const rowNode = $(DataTable.row(position).node());

                    if (rowNode.length) {
                        // Scroll into view
                        rowNode[0].scrollIntoView({ behavior: 'smooth', block: 'center' });

                        // Highlight the row
                        rowNode.addClass('highlight');

                        // Remove highlight after 2 seconds
                        setTimeout(() => rowNode.removeClass('highlight'), 2000);
                    }
                }, 300);
            });
        });
    }
}